import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('physicalLocations.addAndEdit.errors.name'),
  extra: Yup.string().required('physicalLocations.addAndEdit.errors.extra'),
});
